import React from "react";
import logo from "../assets/images/logo/logo.png";

const Header = () => {
  return (
    <>
      <div className="flex justify-center p-4">
        <img src={logo} alt="logo" className="w-auto h-10" />
      </div>
    </>
  );
};

export default Header;
